import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { createCall } from '@services/api-calls/apicalls.service';
import { HeadersService } from '@services/api-calls/headers.service';
import { methodType, headerType } from '@config/customTypes.config';

@Injectable()
export class CRUDService extends HeadersService {
    constructor(private http: HttpClient) {
        super(http);
    }

    /**
     * One function to perform all of 4 actions.
     * A.K.A -> CRUD
     *
     * @param method action to perform
     * @param call ${backurl}/api/v1/[call]
     * @param headerType See headers.service.ts for more info
     * @param id ${backurl}/api/v1/${call}/[id]
     * @param params Url params. Has to be an object with key: value. like: {access: asdf-1234-zxvc-6789, param: true} -> ${backurl}/api/v1/${call}/${id}?access=asdf-1234-zxvc-6789&param=true
     * @param data it could be an object with key value or FormData in case the data has to save any file.
     * @returns Observable with backend response
     */
    run(
        method: methodType = 'read',
        call: string,
        headerType: headerType = 'common',
        id?: string,
        params?: any,
        data?: any
    ): Observable<any> {
        if (!params) {
            params = {};
        }
        params['access'] = localStorage.getItem('user-access');
        let url = createCall(call, id, params);
        let headers = this.getHeaderByType(headerType);

        switch (method) {
            case 'create':
                return this.http.post(url, data, headers);
            case 'read':
                return this.http.get(url, headers);
            case 'update':
                return this.http.put(url, data, headers);
            case 'delete':
                return this.http.delete(url, headers);
        }
    }
}
